export default __webpack_public_path__ + "static/media/backtotop2.53c86689.svg";